// extracted by mini-css-extract-plugin
export default {"productDescription":"Bea-z","featuredDescription":"Cea-z","description":"Dea-z","more":"Eea-z","descriptionSku":"Fea-z"};